<template>
    <b-form inline class="mb-1" @submit.stop.prevent="created">
        <template v-if="showNew">
            <b-container fluid>
                <b-row align-h="center">
                    <label class="sr-only" for="new-client-input-name">Имя</label>
                    <b-input
                            id="new-client-input-name"
                            class="mb-1 mr-2"
                            placeholder="Имя клиента" autofocus
                            v-model.trim="clientName"
                    ></b-input>
                    <b-button variant="danger" class="mb-1 mr-2" @click.stop.prevent="created">Создать клиента
                    </b-button>
                    <b-button variant="primary" class="mb-1 mr-2" @click.stop.prevent="cancel">Отменить
                    </b-button>
                </b-row>
            </b-container>
        </template>
        <b-button v-else block variant="danger" class="mb-1" @click.stop.prevent="createNew">Добавить клиента
        </b-button>
    </b-form>
</template>

<script>
    export default {
        data() {
            return {
                clientName: '',
                showNew: false,
            }
        },
        methods: {
            createNew() {
                this.showNew = true;
            },
            cancel() {
                this.clientName = '';
                this.showNew = false;
            },
            created() {
                this.$emit('create', this.clientName);
                this.cancel();
            }
        }
    }
</script>